var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "13px",
    viewBox: "0 0 11 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---1-edytor",
    transform: "translate(-371.000000, -776.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dodaj-artykul",
    transform: "translate(233.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(37.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(46.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "U",
    transform: "translate(55.403809, 1.005859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05175781,10.1308594 C6.25488281,10.1308594 7.20052083,9.80501302 7.88867188,9.15332031 C8.57682292,8.5016276 8.92089844,7.60611979 8.92089844,6.46679688 L8.92089844,6.46679688 L8.92089844,0 L7.75878906,0 L7.75878906,6.5078125 C7.75878906,7.34635417 7.53092448,7.99007161 7.07519531,8.43896484 C6.61946615,8.88785807 5.97005208,9.11230469 5.12695312,9.11230469 C4.24283854,9.11230469 3.57291667,8.8889974 3.1171875,8.44238281 C2.66145833,7.99576823 2.43359375,7.35546875 2.43359375,6.52148438 L2.43359375,6.52148438 L2.43359375,0 L1.27148438,0 L1.27148438,6.43945312 C1.27148438,7.58789062 1.6007487,8.49023438 2.25927734,9.14648438 C2.91780599,9.80273438 3.84863281,10.1308594 5.05175781,10.1308594 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Decoration",
    points: "2.20268248e-13 12.1411675 10 12.1411675 10 11.366428 2.20268248e-13 11.366428"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionUnderline);
export default __webpack_public_path__ + "static/media/optionUnderline.55be77bf9e660519a984d0db5fa6340d.svg";
export { ForwardRef as ReactComponent };